import MoreDropdown from './moreDropdown.vue';

MoreDropdown.install = function(Vue){
  Vue.component('MoreDropdown', MoreDropdown);
};

export default MoreDropdown;